<template>
	<Transition name="fade">
		<div
			v-if="show"
			class="fixed top-0 bottom-0 right-0 left-0 bg-transparent-s-dark"
			@click="$emit('cancel')"
		></div>
	</Transition>
	<Transition name="fade">
		<div
			v-if="show"
			class="absolute bottom-0 bg-neutral-25 width-full rounded-4 px-6 pt-5 z-5 border-xs border-neutral-200"
		>
			<div class="d-flex flex-column gap-4">
				<h3 class="text-neutral-900 text-title-m">
					{{ title }}
				</h3>
				<p v-if="description" class="text-neutral-600 text-body-xl">{{ description }}</p>
			</div>
			<div class="d-flex gap-4 justify-end py-4">
				<PButton type="outlined" color="neutral" @click="$emit('cancel')">
					{{ cancelText }}
				</PButton>
				<PButton color="error" @click="$emit('confirm')">
					{{ acceptText }}
				</PButton>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
	interface Props {
		show: boolean
		title: string
		description?: string
		acceptText: string
		cancelText: string
	}
	defineProps<Props>()
	defineEmits(['confirm', 'cancel'])
</script>
